import { useAtom } from "jotai";
import { packAtom } from "../../lib/atoms";
import { FC } from "react";
import Title from "../ui/Title";
import Box from "../ui/Box";
import { Switch } from "../ui/switch";
import bronze from "../../assets/img/bronze.png";
import silver from "../../assets/img/silver.png";
import gold from "../../assets/img/gold.png";
import { Pack } from "../../lib/interfaces/pack.interface";
import { Alert } from "../ui/alert";
import { AlertCircle } from "lucide-react";

interface Props {
  packs: Pack[];
}

const ChoixPack: FC<Props> = ({ packs }) => {
  const [packChoisi, setPackChoisi] = useAtom(packAtom);

  return (
    <>
      <Title order={2}>Packs d'options (assurances, éco-contribution ...)</Title>
      <Alert className='mt-4 border-blue-800 bg-blue-50'>
        <div className='font-md text-blue-700 font-semibold'>Nouveauté 2024</div>
        <div>
          L'éco-contribution et les assurances sont désormais regroupées en formules-packs.{" "}
          <strong>Chaque formule inclus l'éco-contribution</strong> et une couverture d'assurance différente.
          <br />
          <strong>Attention : </strong>Les packs sont payants dès la première ruche.
        </div>
      </Alert>
      <div className='flex flex-col gap-3 mt-4'>
        <Box className='flex flex-row gap-4'>
          <Switch
            id='pas-assu'
            checked={packChoisi === null}
            onCheckedChange={(checked) => {
              if (checked) {
                setPackChoisi(null);
              }
            }}
          />
          <label htmlFor='pas-assu' className='flex flex-col gap-1 font-semibold'>
            Aucun pack
          </label>
        </Box>
        {packs.map((pack, i) => (
          <Box key={pack.id} className='flex flex-col md:flex-row gap-2 md:gap-4 justify-between'>
            <div className='flex flex-row gap-4'>
              <Switch
                id={pack.id}
                checked={packChoisi === pack}
                onCheckedChange={(checked) => {
                  if (checked) setPackChoisi(pack);
                }}
              />
              <div className='flex flex-col gap-0.5'>
                <label className=' font-semibold' htmlFor={pack.id}>
                  {pack.nom}
                </label>
                <div className='font-medium text-sm'>Inclus :</div>
                <div className='text-sm'>+ {pack.description}</div>
                <div className='text-sm'>+ Prise en charge du paiement de l'éco-contribution</div>
                <div className='text-sm'>+ Accès aux webinaires proposés par l'Abeille de France</div>
                <div className='mt-1 italic flex items-center gap-3 text-sm'>
                  <AlertCircle className='text-slate-400' size={15} /> Les packs sont payants dès la première ruche
                </div>
              </div>
            </div>
            <div className='flex flex-row md:flex-col gap-3 justify-between items-end'>
              <div>
                <img className='h-14' src={i === 0 ? bronze : i === 1 ? silver : gold} alt='' />
              </div>
              <div className='w-36 text-center px-2 py-1 bg-slate-200 text-slate-800 rounded-lg font-medium'>
                {(pack.prix / 100).toFixed(2)}€ / ruche
              </div>
            </div>
          </Box>
        ))}
      </div>
    </>
  );
};

export default ChoixPack;
